module.exports = __webpack_public_path__ + "bed-title.0fdac139.png";